module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section"
  }, [_c('h2', [_vm._v("Privacy Choices")]), _vm._v(" "), _c('p', [_vm._v("\n    YouSound takes your privacy seriously, so we provide you with a variety of\n    choices regarding how we use the information we collect about you, and how\n    you can manage your online privacy when you use the YouSound Services.\n    Here’s how you can exercise those choices.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    If you want more information or have questions, contact us at\n    privacy@yousound.com.\n  ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-family": "'Open Sans', sans-serif",
      "font-size": "16px",
      "border-collapse": "collapse"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_c('strong', [_vm._v("If you want to:")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_c('strong', [_vm._v("Do this:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Update your user profile information and preferences\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Update Profile\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Disable or deactivate your YouSound user account\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Disable Account\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Close your account and delete your profile information. Note: If you\n          close your account, YouSound may retain other information about you\n          for the activities described in our Terms, or as permitted or\n          required by applicable law.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          (Verified Artists) Download your songs\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Log into your account, play your own songs, and use the download\n          button on the footer player to download your songs\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          To disable activity sharing with friends, you must close your\n          account\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          De-link your account from your other accounts and services (such as\n          Stripe.com) and opt out of sharing between the YouSound Services and\n          Stripe.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Bank Details\" and click \"Disconnect\n          Stripe\""), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Opt out of non-transactional email or push notifications\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Use the “unsubscribe” link included in each email\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Opt out of marketing emails from YouSound\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Use the “unsubscribe” link included in each email\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Opt out of Google Analytics in connection with your use of the\n          YouSound Services\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://tools.google.com/dlpage/gaoptout"
    }
  }, [_vm._v("Click here")])])])])]), _vm._v(" "), _c('h3', [_vm._v("EEA DATA SUBJECT RIGHTS")]), _vm._v(" "), _c('p', [_vm._v("\n    Residents of the European Economic Area (“EEA”) can exercise certain data\n    subject rights available to them under applicable data protection laws.\n    Where such rights apply, we will comply with requests to exercise these\n    rights in accordance with applicable law. Please note, however, that we\n    are not legally required to accommodate such requests under all\n    circumstances, which may include if we need to keep processing your\n    information for our legitimate interests or to comply with a legal\n    obligation.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    We may request you provide us with information necessary to confirm your\n    identity (such as your IP address, date of birth, transaction IDs, and\n    email address) before responding to your request."), _c('br'), _c('br')]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-family": "'Open Sans', sans-serif",
      "font-size": "16px",
      "border-collapse": "collapse"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px",
      "font-size": "18px",
      "text-align": "left"
    }
  }, [_vm._v("\n          If you want to:\n        ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px",
      "font-size": "18px",
      "text-align": "left"
    }
  }, [_vm._v("\n          Do this:\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Obtain access to or a copy of certain personal information we hold\n          about you.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          If you want to see your account information, login, then go to the\n          “Settings” page, then click \"View All of Your User Submitted Data\"\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Update personal information which is out of date or incorrect\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          To update your account or profile information, login, then go to the\n          “Settings” page, and update out-of-date or incorrect information.\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Delete certain personal information which we are holding about you\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\". Your\n          information is permanently deleted within 7 days. View our Terms\n          clause \"Personal Information\" to see the specifics."), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Restrict the way that we process and disclose specific personal\n          information about you.\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\"."), _c('br')])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Transfer your personal information to a third-party provider of\n          services\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          To allow users to send and accept payments, we use Stripe. To remove\n          Stripe from your account, go to “Settings”, then click \"Bank\n          Details\" and click \"Disconnect Stripe\".\n        ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Object to the processing of your personal information\n        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "border": "1px solid #d7d7d7",
      "padding": "16px"
    }
  }, [_vm._v("\n          Go to “Settings”, then click \"Cancel My Account\"."), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33c74878","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/terms/components/privacy_choice_tab.vue
// module id = 1675
// module chunks = 180